// tslint:disable:max-line-length
import { UiHelperService } from '../../ui-helper/services/ui-helper.service';
import { CoreAuthService } from '../../auth/services/core-auth.service';
import { Router, ActivationEnd, NavigationEnd } from '@angular/router';
import { IAnalytics } from '../interfaces/analytics.interface';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    defaultAnalytics: IAnalytics = {};

    constructor(private router: Router, private authService: CoreAuthService, private helper: UiHelperService) {
        this.listenToRouter();
    }

    push(analytics: IAnalytics) {
        // console.log({ local: JSON.parse(JSON.stringify(analytics)), global: this.analytics, merged: { ...this.analytics, ...analytics } });
        if (!analytics.dontPush && this.helper.isBrowser) {

            analytics = { ...this.defaultAnalytics, ...analytics };

            if (analytics.useAuthInfo) { analytics.category = this.getRegisterInfo(analytics.category); }
            // tslint:disable-next-line: no-string-literal
            if (window['dataLayer']) {
                // tslint:disable-next-line: no-string-literal
                window['dataLayer'].push(
                    {
                        Category: analytics.category,
                        Action: analytics.action,
                        Label: analytics.label,
                        SubjectId: analytics.subjectId,
                        WorkflowDescription: analytics.workflowDescription,
                        WorkflowStep: analytics.workflowStep,
                        WorkflowTotalStep: analytics.workflowTotalStep,
                        event: 'auto_event'
                    });
            } else {
                console.log(`Can't push to google analytics`, analytics);
            }
        }
    }

    getRegisterInfo(field: string): string {
        if (!field || (field.includes('registered') || field.includes('anonymous'))) { return field; }
        return `${field} - ${this.authService.isUserAuthenticated() ? 'registered' : 'anonymous'}`;
    }

    getDefaultAnalytics(): IAnalytics {
        return this.defaultAnalytics;
    }

    setDefaultAnalytics(analytics: IAnalytics): void {
        this.defaultAnalytics = analytics;
    }

    private listenToRouter(): void {
        let isNewNavigation = true;
        this.router.events.pipe(filter(x => x instanceof ActivationEnd || x instanceof NavigationEnd)).subscribe((res: any) => {
            if (res instanceof NavigationEnd) {
                isNewNavigation = true;
            } else if (isNewNavigation) {
                const routeAnalytics = res.snapshot.data.analytics;
                if (routeAnalytics) { this.defaultAnalytics = routeAnalytics; }
                isNewNavigation = false;
            }
        });
    }
}
